var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.68311H16.504C18.987 3.68311 21 5.69611 21 8.17911V17.1881C21 19.6701 18.987 21.6831 16.504 21.6831H7.496C5.013 21.6831 3 19.6701 3 17.1871V8.18311C3 5.69811 5.015 3.68311 7.5 3.68311V3.68311Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0948 16.1742L9.2828 13.5002C9.2818 13.4992 6.9568 12.7742 6.9568 12.7742C6.6908 12.6912 6.6778 12.3182 6.9388 12.2182L15.7898 8.80417C16.1168 8.67817 16.4538 8.96517 16.3818 9.30817L14.8948 16.3162C14.8078 16.7272 14.3248 16.9102 13.9878 16.6602L11.8758 15.1002L10.6308 16.3122C10.4558 16.4802 10.1658 16.4052 10.0948 16.1742V16.1742Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.6d436af4596a28c32cf2828376ca6ada.svg";
export { ForwardRef as ReactComponent };